import { getDocumentDimensions } from "./getDocumentDimensions";

export function positionTooltipRight(
  triggerRect: { top: number; left: number; bottom: any; right: number },
  tooltipRect: { height: number; width: number },
  offset = 8
) {
  let { width: windowWidth, height: windowHeight } = getDocumentDimensions();
  if (!triggerRect || !tooltipRect) {
    return {};
  }

  let collisions = {
    top: triggerRect.top - tooltipRect.height < 0,
    right: windowWidth < triggerRect.left + tooltipRect.width,
    bottom: windowHeight < triggerRect.bottom + tooltipRect.height + offset,
    left: triggerRect.left - tooltipRect.width < 0
  };

  let directionRight = collisions.right && !collisions.left;
  let directionUp = collisions.bottom && !collisions.top;

  return {
    left: directionRight
      ? `${triggerRect.right - tooltipRect.width + window.pageXOffset}px`
      : `${triggerRect.right + offset + window.pageXOffset}px`,
    top: directionUp
      ? `${triggerRect.top -
          offset -
          tooltipRect.height +
          window.pageYOffset}px`
      : `${triggerRect.top -
          tooltipRect.height / 2 +
          offset +
          window.pageYOffset}px`
  };
}
